import { AlertTriangle } from "lucide-react";
import { modelPageUrl } from "@jammable/ui-core";
import Link from "next/link";

export function Error({ modelUrlParam }: { modelUrlParam: string }) {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-rounded-[30px] tw-bg-jam-lav tw-px-6 tw-py-8 tw-text-center md:tw-rounded-[36px] md:tw-px-10">
      <span className="tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-red-500">
        <AlertTriangle size={26} />
      </span>
      <h2 className="jam-display tw-m-0 tw-text-[26px] tw-font-extrabold tw-text-jam-ink">
        This cover didn&apos;t come out
      </h2>
      <p className="tw-m-0 tw-max-w-md tw-text-[15px] tw-font-semibold tw-text-jam-muted">
        Your credit has been added back. If you retry the conversion it may
        succeed!
      </p>
      <div className="tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-2 sm:tw-flex-row">
        <Link
          className="tw-rounded-full tw-bg-jam-purple tw-px-6 tw-py-3.5 tw-text-sm tw-font-extrabold tw-text-white tw-no-underline"
          href={modelPageUrl(modelUrlParam)}
        >
          Try again
        </Link>
        <Link
          className="tw-rounded-full tw-bg-white tw-px-6 tw-py-3.5 tw-text-sm tw-font-extrabold tw-text-jam-ink tw-no-underline"
          href="mailto:support@jammable.com"
        >
          Contact support
        </Link>
      </div>
    </div>
  );
}
